import { render, staticRenderFns } from "./CreateButtonMobile.vue?vue&type=template&id=d8584f6e&scoped=true&"
import script from "./CreateButtonMobile.vue?vue&type=script&lang=js&"
export * from "./CreateButtonMobile.vue?vue&type=script&lang=js&"
import style0 from "./CreateButtonMobile.vue?vue&type=style&index=0&id=d8584f6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8584f6e",
  null
  
)

export default component.exports